var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 5.66797H18.3327V9.0013H1.66602V5.66797Z",
    fill: "#E53323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.668H9.16667V19.0013H2.5V10.668Z",
    fill: "#E53323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.832 10.668H17.4987V19.0013H10.832V10.668Z",
    fill: "#E53323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33268 5.66927C6.24935 5.58594 6.08268 5.5026 6.08268 5.41927C5.91602 5.2526 5.83268 5.08594 5.83268 4.83594C5.83268 4.58594 5.91602 4.41927 6.08268 4.2526C6.16602 4.08594 6.41602 4.0026 6.66602 4.0026C6.91602 4.0026 7.08268 4.08594 7.24935 4.2526C7.49935 4.5026 7.91602 5.08594 8.24935 5.66927H11.7494C12.166 5.08594 12.4993 4.5026 12.8327 4.2526C12.916 4.08594 13.166 4.0026 13.3327 4.0026C13.5827 4.0026 13.7494 4.08594 13.916 4.2526C14.2494 4.58594 14.2494 5.08594 13.916 5.41927C13.8327 5.5026 13.7493 5.58594 13.666 5.66927H15.7493C16.0827 4.7526 15.916 3.7526 15.166 3.08594C14.2494 2.16927 12.5827 2.16927 11.666 3.08594C11.3327 3.41927 10.666 4.33594 10.0827 5.33594C9.49935 4.33594 8.83268 3.41927 8.49935 3.08594C7.49935 2.08594 5.83268 2.08594 4.83268 3.08594C4.41602 3.5026 4.16602 4.16927 4.16602 4.83594C4.16602 5.08594 4.16602 5.41927 4.24935 5.66927H6.33268Z",
    fill: "#E53323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.4ea50c81b44b972ff0188a178dacc964.svg";
export { ForwardRef as ReactComponent };